import React, { FC, useEffect, useState } from 'react'
import { IonPage, IonContent, useIonViewWillEnter, useIonViewWillLeave, useIonRouter, useIonViewDidEnter } from '@ionic/react'
import { observer } from 'mobx-react'
import { cartMobx, orderMobx, discountMobx } from 'restaurant'
import { decorationMobx, payPlanMobx, payRechargeMobx, thirdPartyMobx } from '@mobxStore'
import { alertLayer, handleEleScrollTo, useHistoryNew } from '@utils'
import { CartResultPrice, CheckoutItems, PayAndRechargeTip } from '@pages/checkout/component'
import { MktController, RestoreOrderController } from '@ctrls/index'
import { store, getParams, useThrottle } from '@dt/fe-utils'
import CartFooter from './component/CartFooter'
import PayAndRechargeList from '@pages/checkout/component/Pay/PayAndRechargeList'
import '@pages/checkout/component/CartCheck/index.scss'
import '@pages/checkout/index.scss'
import './index.scss'

// props
interface IProps {
}

const PosCheckout: FC<IProps> = ({ }) => {
  const history = useHistoryNew()
  const ionicRoute = useIonRouter()
  let { posOrdersId } = getParams()
  const [hasPayAndRechargeList, setHasPayAndRechargeList] = useState(false)
  const [showPayAndRechargeTip, setShowPayAndRechargeTip] = useState(false)

  const calcPayAndRecharge = (e?: any) => {
    const _scrollTop = e?.detail?.scrollTop
    const _clientHeight = (document.querySelector('#CheckoutContent') as any)?.clientHeight
    const _offsetTop = (document.querySelector('#PayAndRechargeList') as any)?.offsetTop
    if (!payRechargeMobx.memberCardCanFullpay) {
      if (e) {
        if (history.getPrevState() === '/menu' && _scrollTop + _clientHeight - 40 < _offsetTop && showPayAndRechargeTip) {
          setShowPayAndRechargeTip(true)
        } else {
          setShowPayAndRechargeTip(false)
        }
      } else {
        setShowPayAndRechargeTip(true)
      }
    } else {
      setShowPayAndRechargeTip(false)
    }
  }

  // 订单结束提示
  const handleOrderEnd = (isForce: boolean = false) => {
    if (isForce || !['Pending', 'Paying'].includes(orderMobx.order.status)) {
      alertLayer({
        message: i18n.t('checkout.orderHasFinishedAndClose'),
        cssClass: 'common-alert no-button',
        backdropDismiss: false,
      })
      cartMobx.clear()
    }
  }

  const handleScrollToPayAndRechargeList = () => {
    const _offsetTop = (document.querySelector('#PayAndRechargeList') as any)?.offsetTop
    handleEleScrollTo?.({
      selector: '#PosCheckoutContent',
      y: _offsetTop || 0,
    })
    setShowPayAndRechargeTip(false)
  }

  const handleScroll = useThrottle(function (e: any) {
    calcPayAndRecharge(e)
  }, 100, [showPayAndRechargeTip])

  // useIonViewWillEnter
  useIonViewWillEnter(() => {
    cartMobx.setPosOrderPay(true)
    if (!posOrdersId) {
      posOrdersId = store.get(RestoreOrderController.localKey())
    }
    if (posOrdersId) {
      cartMobx.setOrdersId(posOrdersId).then(() => {
        if (!['Pending', 'Paying'].includes(orderMobx.order.status)) {
          return
        }
        if (decorationMobx.tabBarVisible) {
          decorationMobx.setTabBarVisible(false)
          document.querySelector('ion-tab-bar')?.classList.add('hide')
        }
        setTimeout(() => {
          discountMobx.calcCart()
          payPlanMobx.beginCalc()
        }, 500)
      })
      MktController.checkLogin(history, true, false)
    } else {
      cartMobx.setPosOrderPay(false)
      handleOrderEnd(true)
    }
  })

  // useIonViewWillLeave
  useIonViewWillLeave(() => {
    cartMobx.setPosOrderPay(false)
    payPlanMobx.endCalc()
  })

  // useIonViewDidEnter
  useIonViewDidEnter(() => {
    calcPayAndRecharge()
  })

  // hack for ionic route bug
  useEffect(() => {
    if (ionicRoute.routeInfo.lastPathname === '/posCheckout' && ionicRoute.routeInfo.routeDirection === 'back') {
      ionicRoute.routeInfo.pushedByRoute = '/posCheckout'
    }
  }, [ionicRoute])

  // useEffect
  useEffect(() => {
    handleOrderEnd()
  }, [orderMobx.order.status])

  return (
    <IonPage className='cart-page pos-cart-page'>
      <IonContent
        id='PosCheckoutContent'
        className='checkout-content'
        scrollEvents
        onIonScroll={(e) => { handleScroll(e) }}
      >
        <div className='cart-page-content'>
          <CheckoutItems />
          <CartResultPrice />
        </div>
        {
          !payRechargeMobx.memberCardCanFullpay && !thirdPartyMobx.checkCoupons.length && <PayAndRechargeList onChange={(val) => setHasPayAndRechargeList(val)} />
        }
        {
          !cartMobx.needPack && !thirdPartyMobx.checkCoupons.length && <PayAndRechargeTip show={showPayAndRechargeTip && hasPayAndRechargeList} onClick={handleScrollToPayAndRechargeList} />
        }
      </IonContent>
      <CartFooter />
    </IonPage>
  )
}

export default observer(PosCheckout)
